module.exports = __webpack_public_path__ + "img/ccompany-honor-COC-20230510.5837cdac.jpg";